import { render } from "./NotFound.vue?vue&type=template&id=6cbfe8a0&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=6cbfe8a0&scoped=true&lang=css"

import exportComponent from "/home/benjamin/projects/web-case/maxstock-firebase/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbfe8a0"]])

export default __exports__